export const CityConfig = {
  // Get City Config
  GET_CITY_CONFIG: "GET_CITY_CONFIG",
  GET_CITY_CONFIG_SUCCESS: "GET_CITY_CONFIG_SUCCESS",
  GET_CITY_CONFIG_FAILURE: "GET_CITY_CONFIG_FAILURE",

  // clear
  CLEAR_CITY_CONFIG: "CLEAR_CITY_CONFIG",

  // upload
  UPLOAD_CITY_CONFIG: "UPLOAD_CITY_CONFIG",
  UPLOAD_CITY_CONFIG_SUCCESS: "UPLOAD_CITY_CONFIG_SUCCESS",
  UPLOAD_CITY_CONFIG_FAILURE: "UPLOAD_CITY_CONFIG_FAILURE",

  // download city config excel template
  DOWNLOAD_CITY_CONFIG_EXCEL_TEMPLATE: "DOWNLOAD_CITY_CONFIG_EXCEL_TEMPLATE",
  DOWNLOAD_CITY_CONFIG_EXCEL_TEMPLATE_SUCCESS:
    "DOWNLOAD_CITY_CONFIG_EXCEL_TEMPLATE_SUCCESS",
  DOWNLOAD_CITY_CONFIG_EXCEL_TEMPLATE_FAILURE:
    "DOWNLOAD_CITY_CONFIG_EXCEL_TEMPLATE_FAILURE",
};
